module.exports = __webpack_public_path__ + "img/logo-full.220d1c5d.svg";